/** Steps項目 */
export const B100_STEPS_ITEMS = [
  { label: '団体プロフィール内容入力' },
  { label: '登録内容確認' },
  { label: '完了' },
];
